<ng-container *ngIf="layoutVarsResponse">
  <div class="auth-content">
    <router-outlet></router-outlet>


    <!-- <div class="row ask-for-help">
      <div class="col-12">
        Está com dúvidas ou precisando de ajuda?
      </div>
      <ng-container *ngIf="!contacts || contacts.length == 0">
        <div class="col-12 phone-number">
          <span class="fal fa-phone-alt"></span><a href="tel:551640421197">+55
            16 4042.1197</a>
        </div>
        <div class="col-12 phone-number">
          <span class="mdi mdi-whatsapp"></span><a href="https://wa.me/551639043702">+55 16 3904.3702</a>
        </div>
      </ng-container>
      <ng-container *ngIf="contacts && contacts.length > 0">
        <div class="col-12 phone-number" *ngFor="let contact of contacts">
          <ng-container *ngIf="contact.type == 'PHONE_NUMBER'">
            <span class="fal text-white fa-phone-alt"></span>
            <a href="tel:{{contact.contact}}" class="text-white">{{contact.contact}}</a>
          </ng-container>
          <ng-container *ngIf="contact.type == 'WHATSAPP'">
            <span class="fal text-white mdi mdi-whatsapp"></span>
            <a href="https://wa.me/55{{contact.contact}}" target="_blank" class="text-white">{{contact.contact}}</a>
          </ng-container>
          <ng-container *ngIf="contact.type == 'EMAIL'">
            <span class="fal text-white fa-envelope"></span>
            <a href="mailto:{{contact.contact}}" class="text-white">{{contact.contact}}</a>
          </ng-container>
          <ng-container *ngIf="contact.type == 'ADDRESS'">
            <span class="fal fa-map-marker-alt text-white"></span>
            <span class="text-white" style="font-weight: normal;">{{contact.contact}}</span>
          </ng-container>
        </div>
      </ng-container>
      <div class="col-md-12">
        <span class="attendance-info" style="font-size: 11px;">(De segunda a sexta das 9h às 18h)</span>
      </div>
    </div> -->
  </div>
</ng-container>